import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  text: 'Descarga el Kit e identifica tus síntomas principales con el Diario de Bio-Feedback.'
}, {
  num: '02',
  text: 'Implementa un Micro-ajuste cada 24 horas (empezando por la proteína y el sueño).'
}, {
  num: '03',
  text: 'Recupera tu claridad mental y tu descanso profundo en menos de una semana.'
}];
export function HowItWorks() {
  return <section className="w-full bg-cream py-20 md:py-32" data-id="element-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-serif text-text-brown tracking-wide mb-4" data-id="element-53">
            Cómo funciona
          </h2>
          <div className="w-24 h-[1px] bg-taupe mx-auto" data-id="element-54"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-55">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-[1px] bg-taupe/40 z-0" data-id="element-56"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-57">
              <div className="w-24 h-24 bg-ivory rounded-full flex items-center justify-center mb-6 shadow-sm border border-taupe/30" data-id="element-58">
                <span className="font-serif text-4xl text-gold" data-id="element-59">
                  {step.num}
                </span>
              </div>
              <p className="text-text-brown-light font-light leading-relaxed max-w-xs" data-id="element-60">
                {step.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}